import MovieCard from '@/components/feature/MovieCard';
import type { Movie } from '@/mocks/movies';

interface RelatedMoviesProps {
  movies: Movie[];
}

export default function RelatedMovies({ movies }: RelatedMoviesProps) {
  return (
    <section className="w-full px-4 md:px-8 py-12 md:py-16 bg-background-900">
      <div className="flex items-center gap-3 mb-8">
        <span className="w-1 h-6 rounded-full bg-accent-500"></span>
        <h2 className="text-xl md:text-2xl font-heading font-black text-foreground-50">相关推荐</h2>
        <span className="text-xs text-foreground-400">根据类型与主演匹配</span>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
        {movies.map((movie) => (
          <MovieCard key={movie.id} movie={movie} />
        ))}
      </div>
    </section>
  );
}